import { ReactNode } from "react";
import { EUnstakeMode, TUnstakeMode } from "./types";
import { HourglassHighIcon, LightningIcon } from "@phosphor-icons/react";

// Unstake mode configurations
export const UNSTAKE_MODES: Record<
  TUnstakeMode,
  {
    waitingTime: string;
    fees: string;
    displayName: string;
    icon?: string | ReactNode;
    tooltip?: string;
  }
> = {
  [EUnstakeMode.INSTANT]: {
    waitingTime: "< 1 min",
    fees: "0.2%",
    displayName: "Instant",
    icon: (
      <LightningIcon weight="fill" color="rgba(112, 161, 255, 1)" size={16} />
    ),
    tooltip: "Instant unstaking is available",
  },
  [EUnstakeMode.STANDARD]: {
    waitingTime: "15-21 days",
    fees: "0",
    displayName: "Standard",
    icon: <HourglassHighIcon size={16} color="black" />,
    tooltip:
      "Standard withdrawals take around 14+ days due to Ethereum delays. A claim is required after processing.",
  },
};

// Default unstake tab data
export const DEFAULT_UNSTAKE_DATA = {
  exchangeRate: "1 rsETH = 0.9851 ETHx",
  outputToken: "ETH",
  buttonText: "Connect wallet",
};

// Button text configurations for unstake modes
export const UNSTAKE_BUTTON_TEXT = {
  [EUnstakeMode.INSTANT]: "Request unstaking",
  [EUnstakeMode.STANDARD]: "Request unstaking",
};

// Exchange information labels
export const EXCHANGE_LABELS = {
  youWillGet: "You will get",
  exchangeRate: "Exchange rate",
  waitingTime: "Waiting time",
  fees: "Fees",
};

// Withdraw list configuration
export const WITHDRAW_CONFIG = {
  headers: {
    amount: "Amount",
    status: "Status",
  },
  emptyMessage: "No withdrawal requests found",
  claimButtonText: "Claim",
  statusLabels: {
    available: "Available",
    pending: "NA",
    completed: "Completed",
  },
};
